module.exports = __webpack_public_path__ + "static/media/hero-background.49a095ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/page/parallaxBasic/hero-background.jpg
// module id = 92
// module chunks = 0